import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import { Dimmer } from '../components/spinner';

import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

    ;

import axios from "axios";


const CatalogoCuentasAsientos = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idalmacen: '',
        descripcion: '',
        responsable: '',
        ventas: false
    });
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CODIGO', textAlign: 'center', backgroundColor: "rgba(5, 81, 130, 1)" },
        { label: 'DESCRIPCION', textAlign: 'center', backgroundColor: "rgba(5, 81, 130, 1)" },
        { label: 'ID', textAlign: 'center', backgroundColor: "rgba(5, 81, 130, 1)" },

    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idplancuenta.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.codigocuenta.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const handleSearch1 = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idplancuenta.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.codigocuenta.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        let endpoint;

        if (props.tabla === 0) {

            let campos = '*';
            let nomtab = 'plancuenta';
            let condi = 'cargable = true AND idefiscal = ' + parseInt(idefiscal);
            let orden = 'idplancuenta';

            endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;


        } else {

            endpoint = `${op.conexion}/api/contabilidadfis/catalogocontable3/?efiscal=${parseInt(idefiscal)}&carga=${true}`;
        }


        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setRecords(response.data);
                }
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {
            setActivate(false);
        })

    }


    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setActivo(true);
        setRecords([]);
        setValues({
            idalmacen: '',
            descripcion: '',
            responsable: '',
            ventas: false
        });
        setFilterFn({ fn: items => { return items; } });
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }


    const seleccionarCuenta = () => {

        props.onHideAceptaCatalogo(values);

    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        let idcuenta;
        setActivo(false);
        if (parseInt(props.tabla) === 0) {
            setValues({
                idplancuenta: item.idplancuenta,
                codigocuenta: item.codigocuenta,
                descripcion: item.descripcion,

            });
        } else {
            setValues({
                idplancuenta: item.idplancuenta,
                codigocuenta: item.codigocuenta,
                descripcion: item.descripcion,
                idcuentacontable: item.idcuentacontable

            });
        }

        //btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();

            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light"><h3>Seleccionar Cuenta</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={props.tabla === 0 ? handleSearch : handleSearch1} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: values.idplancuenta === item.idplancuenta ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <td className='py-2 text-left'>{item.codigocuenta}</td>
                                        <td className='py-2 text-left'>{item.descripcion}</td>
                                        <td className='py-2 text-center'>{props.tabla === 0 ? item.idplancuenta : item.idcuentacontable}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarCuenta}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoCuentasAsientos;